import { useState } from 'react'
import { useSelector } from 'react-redux'
import { LockAction } from '../../../../../common/LockAction'
import { Icon } from '../../../../../common/html/icon'
import EventEmitter, {
  SHOW_ORDER_BUSINESS_CREDIT_REPORT,
  SHOW_POPUP_FACTSHEET,
  SHOW_POPUP_FOLLOW_ALERT,
  SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO,
} from '../../../../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../../../layout/store/slice'
import { MAIN_SCREEN } from '../../../../../tool/dynamicReport/constant'
import PopupKeepSetting from '../../../../../tool/dynamicReport/preferenceSetting/detailTemplate/PopupKeepSetting'
import { getMapIconFollowUserType } from '../helper'
import { selectCompanyInfo } from '../store/slice'
import { Item } from './Item'

export const MinimumAction = () => {
  const userType = useSelector(selectUserType)
  const companyInfo = useSelector(selectCompanyInfo)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const [isShow, setIsShow] = useState(false)

  const mapIconFollowUserType = getMapIconFollowUserType(
    userType,
    companyInfo?.allowDynamicReport,
    () => {
      EventEmitter.dispatch(SHOW_ORDER_BUSINESS_CREDIT_REPORT, true)
    },
    () => {
      setIsShow(true)
    },
    () => {
      EventEmitter.dispatch(SHOW_POPUP_FACTSHEET, true)
    },
    () => {
      EventEmitter.dispatch(SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO, true)
    },
    () => {
      EventEmitter.dispatch(SHOW_POPUP_FOLLOW_ALERT, true)
    },
    AUTHORIZATION_API,
  )

  return (
    <>
      {[
        mapIconFollowUserType['icon-follow'],
        mapIconFollowUserType['icon-folder-plus'],
        mapIconFollowUserType['icon-sim-card-download'],
        mapIconFollowUserType['icon-pdf'],
        mapIconFollowUserType['icon-description'],
      ].map((item, index) => {
        return (
          <LockAction enable={item.isLock} key={index}>
            <div className="positionRelative">
              <Item
                item={{
                  ...item,
                  label:
                    index === 0
                      ? item.label(companyInfo.isFollowed)
                      : item.label,
                }}
              />

              {item.isLock && (
                <Icon
                  className="icon-lock"
                  style={{
                    color: '#9C9C9C',
                    fontSize: 10,
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    transform: 'translate(0, -50%)',
                  }}
                />
              )}
            </div>
          </LockAction>
        )
      })}
      <PopupKeepSetting
        isShow={isShow}
        setIsShow={setIsShow}
        data={{
          organizationId: companyInfo.organizationId,
          companyType: companyInfo.companyType,
          mainScreen: MAIN_SCREEN.COMPANY_ANALYSIS,
        }}
      />
    </>
  )
}
